export enum ConclusieDiagnoseOption {
    geen_afwijkingen = 'Geen afwijkingen',
    ja = 'Ja',
    nog_geen_diagnose = 'Nog geen diagnose',
}
